export enum KeyCode {
  Tab = '9',
  Enter = '13',
  ShiftLeft = '16',
  Escape = '27',
  ArrowLeft = '37',
  ArrowUp = '38',
  ArrowRight = '39',
  ArrowDown = '40',
  Slash = '191',
  Space = '32',
  Backspace = '8'
}

export function getKeyCode(event: KeyboardEvent): string {
  if (!event) {
    return '';
  }

  const keyName = event.code || event.key;
  if (keyName !== undefined) {
    if (KeyCode.hasOwnProperty(keyName)) {
      return KeyCode[keyName];
    } else {
      throw new Error(`Key ${keyName} not exist at KeyCode table. Please add it`);
    }
  }
  // eslint-disable-next-line deprecation/deprecation
  if (event.keyCode) {
    // eslint-disable-next-line deprecation/deprecation
    return event.keyCode.toString();
  }

  return '';
}
